import { useNavigate } from "react-router-dom";
import './styles.css'
import useUnicoCamera from "../../hooks/useUnicoCamera";
import { CallbackCamera, DocumentCameraTypes, ErrorPictureResponse, SuccessPictureResponse } from "unico-webframe";
import useGetSession from "../../hooks/useGetSession";
import { useSendToBubble } from "../../hooks/useSendToBubble";
import useValidateSession from "../../hooks/useValidateSession";
import { useEffect, useState } from "react";
import { ReactComponent as Loading}from '../../loading.svg'
import useTypeSession from "../../hooks/useTypeSession";
import useGetDocumentTypeBySession from "../../hooks/useGetDocumentType";

export default function FrontDoc() {
    const navigate = useNavigate();
    const {prepareDocumentCamera, config, loading} = useUnicoCamera();
    const {sendToBubble} = useSendToBubble(process.env.REACT_APP_FRONT_DOC_ENDPOINT || "");
    const isValidSession = useValidateSession();
    const session = useGetSession();
    const documentType = useGetDocumentTypeBySession(session || '');
    const [active, setActive] = useState(false);
    const [docType, setDocType] = useState('');
  
    useEffect(() => {
        if (isValidSession === false) {
          window.location.href = process.env.REACT_APP_REDIRECT_URL || "https://app.banclima.org.br";
          return;
        }
        const getDocument = async () => {
            setDocType(await documentType);
        }
        getDocument();
      }, []);

    const handleFrontDoc = () => {
        const callbacks: CallbackCamera = {
            on: {
                success: (obj: SuccessPictureResponse) => {
                        const session = useGetSession();
                        const type = useTypeSession();
                        const base64 = obj.base64;
                        const encrypted = obj.encrypted;

                        if (session) {
                            sendToBubble({session, base64, encrypted, type});
                            navigate(`/back-doc?session=${encodeURIComponent(session || '')}&type=${encodeURIComponent(type || '')}`, {
                                state: {
                                    session,
                                    type
                                }
                            });
                        } else {
                            setActive(false);
                            console.error("Session is null");
                            return;
                        }
                },
                error: (erro: ErrorPictureResponse) => {
                    console.log(erro);
                    setActive(false);
                }
            }
        };
        setActive(true);
        if (docType === "RG") {
            prepareDocumentCamera(config, DocumentCameraTypes.RG_FRENTE_NOVO, "Frente do RG", true, callbacks);
        }
        if (docType === "CNH") {
            prepareDocumentCamera(config, DocumentCameraTypes.CNH_FRENTE, "Frente da CNH", true, callbacks);
        }
    };

    return (
        <div className="background-container">
            <div className="container">
                <img src={process.env.PUBLIC_URL + '/icon512.png'} alt='Logo' width={300} height={42}></img>
                <div id="box-camera" className={active ? 'active' : 'inactive'}></div>
                <p>Clique no botão abaixo para iniciar a captura da <span><strong>FRENTE</strong></span> do documento</p>
                {loading ? <Loading /> : <button onClick={() => handleFrontDoc()}>Capturar documento</button>}
            </div>
        </div>
    )
}